function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.63163 7.63086C1.82111 7.63086 1.94741 7.75719 1.94741 7.94664V12.052C1.94741 12.2414 2.07374 12.3677 2.2632 12.3677H13.6318C13.8212 12.3677 13.9475 12.2414 13.9475 12.052V7.94664C13.9475 7.75716 14.0739 7.63086 14.2633 7.63086C14.4528 7.63086 14.5791 7.75719 14.5791 7.94664V12.052C14.5791 12.5888 14.1686 12.9993 13.6317 12.9993H2.2632C1.72634 12.9993 1.31582 12.5888 1.31582 12.052V7.94664C1.31582 7.75716 1.44215 7.63086 1.63163 7.63086Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.94728 3.21094H13.9474C14.4843 3.21094 14.8948 3.62146 14.8948 4.15831V6.17939C14.8948 6.62147 14.579 7.00043 14.1684 7.09518L9.2105 8.20044V9.21097C9.2105 9.40045 9.08417 9.52675 8.89471 9.52675H6.99996C6.81048 9.52675 6.68418 9.40042 6.68418 9.21097V8.20044L1.72623 7.09518C1.31568 7.00043 0.999902 6.62147 0.999902 6.17936V4.15828C0.999902 3.62146 1.41042 3.21094 1.94728 3.21094ZM7.31575 8.89518H8.5789V7.63203H7.31575V8.89518ZM1.63149 6.17936C1.63149 6.33725 1.72623 6.46358 1.88413 6.49515L6.68418 7.56885V7.31622C6.68418 7.12674 6.81051 7.00044 6.99996 7.00044H8.89471C9.08419 7.00044 9.2105 7.12676 9.2105 7.31622V7.56885L14.0106 6.49517C14.1684 6.46358 14.2632 6.33728 14.2632 6.17939V4.15831C14.2632 3.96883 14.1369 3.84253 13.9474 3.84253H1.94728C1.7578 3.84253 1.63149 3.96886 1.63149 4.15831V6.17936Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.36857 1H9.5265C10.0634 1 10.4739 1.41052 10.4739 1.94738V2.26316C10.4739 2.45264 10.3475 2.57894 10.1581 2.57894C9.96864 2.57894 9.84231 2.45261 9.84231 2.26316V1.94738C9.84231 1.7579 9.71598 1.63159 9.52653 1.63159H6.36859C6.17911 1.63159 6.05281 1.75792 6.05281 1.94738V2.26316C6.05281 2.45264 5.92648 2.57894 5.73703 2.57894C5.54755 2.57894 5.42125 2.45261 5.42125 2.26316V1.94738C5.42119 1.41052 5.83171 1 6.36857 1Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

function SvgCaseicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseicon);
export default __webpack_public_path__ + "static/media/case.icon.82f88e59.svg";
export { ForwardRef as ReactComponent };